import PropTypes from 'prop-types';
import React from 'react';
import { chairRentalPaymentShape, chairRentalShape } from '../shapes';
import Money from '../../../../common/money';
import MonthSwitcher from '../../../../common/MonthSwitcher';
import Date from '../../../../common/date';
import ChairRentalPaymentRefundButton from '../containers/ChairRentalPaymentRefundButton';
import config from '../../../../../config';

const ChairRentalPaymentStatus = (payment, chairRental) => {
  if (payment.status === 'refunded') {
    return (
      <div className="c-chair-rental-data--small u-type--uppercase">
        Refunded at<br />
        <span className="u-nowrap"><Date format={config.dateTimeFormat}>{payment.refundedAt}</Date></span>
      </div>
    );
  }

  if (payment.status === 'overdue') {
    return (
      <small className="u-type--uppercase u-font--small c-chair-rental-data--red">Overdue</small>
    );
  }

  return (
    <ChairRentalPaymentRefundButton payment={payment} barberId={chairRental.barberId} />
  );
};

const ChairRentalHistory = ({ chairRentalPaymentHistory, fetchForMonth, chairRental }) => (
  <div>
    <MonthSwitcher onChange={month => fetchForMonth(month)} />

    <div className="c-chair-rental-data u-text-center u-co-gray-3 u-mv+" display-if={!chairRentalPaymentHistory.length}>
      There is no payment history to display for selected month.
    </div>

    <div className="c-table-card u-p u-pt0" display-if={chairRentalPaymentHistory.length}>
      <div className="c-table-card__head">
        <div className="c-table-card__cell u-2/10 u-pl0">
          <div className="c-label-new">Paid on</div>
        </div>
        <div className="c-table-card__cell u-3/10">
          <div className="c-label-new">Method</div>
        </div>
        <div className="c-table-card__cell u-3/10">
          <div className="c-label-new">Amount</div>
        </div>
        <div className="c-table-card__cell u-2/10" />
      </div>

      {chairRentalPaymentHistory.map(payment => (
        <div className="c-table-card__row" key={payment.id}>
          <div className="c-table-card__cell u-2/10">
            <div className="c-chair-rental-data u-type--uppercase u-pb--">
              <Date format="MM/DD/YY">{payment.chargedAt}</Date>
            </div>
            <div className="c-chair-rental-data--small u-type--uppercase">
              for <Date format="MM/DD">{payment.fromDate}</Date>
              {' '}-{' '}
              <Date format="MM/DD">{payment.toDate}</Date>
            </div>
          </div>
          <div className="c-table-card__cell u-3/10">
            <div className="c-chair-rental-data u-type--uppercase" display-if={!payment.markedAsPaid}>
              {payment.brand} {payment.last4}
            </div>
            <div className="c-chair-rental-data u-type--uppercase" display-if={payment.markedAsPaid}>
              Marked paid
            </div>
          </div>
          <div className="c-table-card__cell u-3/10">
            <div className="c-chair-rental-data">
              <Money>{payment.amount}</Money>
            </div>
          </div>

          <div className="c-table-card__cell u-2/10 u-position-relative u-text-right">
            {ChairRentalPaymentStatus(payment, chairRental)}
          </div>
        </div>
      ))}
    </div>
  </div>
);

ChairRentalHistory.propTypes = {
  chairRental: chairRentalShape.isRequired,
  chairRentalPaymentHistory: PropTypes.arrayOf(chairRentalPaymentShape),
  fetchForMonth: PropTypes.func.isRequired,
};

ChairRentalHistory.defaultProps = {
  chairRentalPaymentHistory: [],
};

export default ChairRentalHistory;
